__turbopack_context__.v({
  "close": "SearchBar-module-scss-module__XRRpUa__close",
  "fade-in": "SearchBar-module-scss-module__XRRpUa__fade-in",
  "fakeInputButton": "SearchBar-module-scss-module__XRRpUa__fakeInputButton",
  "input": "SearchBar-module-scss-module__XRRpUa__input",
  "isActive": "SearchBar-module-scss-module__XRRpUa__isActive",
  "isOpen": "SearchBar-module-scss-module__XRRpUa__isOpen",
  "mobile-close": "SearchBar-module-scss-module__XRRpUa__mobile-close",
  "mobile-open": "SearchBar-module-scss-module__XRRpUa__mobile-open",
  "open": "SearchBar-module-scss-module__XRRpUa__open",
  "overlay": "SearchBar-module-scss-module__XRRpUa__overlay",
  "popularSearchesDesktop": "SearchBar-module-scss-module__XRRpUa__popularSearchesDesktop",
  "popularSearchesMobile": "SearchBar-module-scss-module__XRRpUa__popularSearchesMobile",
  "root": "SearchBar-module-scss-module__XRRpUa__root",
  "rootInner": "SearchBar-module-scss-module__XRRpUa__rootInner",
  "searchIcon": "SearchBar-module-scss-module__XRRpUa__searchIcon",
  "searchIconWrapper": "SearchBar-module-scss-module__XRRpUa__searchIconWrapper",
  "searchInput": "SearchBar-module-scss-module__XRRpUa__searchInput",
  "searchInputInner": "SearchBar-module-scss-module__XRRpUa__searchInputInner",
  "searchWrapper": "SearchBar-module-scss-module__XRRpUa__searchWrapper",
  "submitButtonDesktop": "SearchBar-module-scss-module__XRRpUa__submitButtonDesktop",
  "submitButtonMobile": "SearchBar-module-scss-module__XRRpUa__submitButtonMobile",
  "submitButtonMobileLight": "SearchBar-module-scss-module__XRRpUa__submitButtonMobileLight",
  "submitButtonWrapper": "SearchBar-module-scss-module__XRRpUa__submitButtonWrapper",
});
